import { render } from "./SingleElection.vue?vue&type=template&id=172697b3&scoped=true"
import script from "./SingleElection.vue?vue&type=script&lang=js"
export * from "./SingleElection.vue?vue&type=script&lang=js"

import "./SingleElection.vue?vue&type=style&index=0&id=172697b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172697b3"]])

export default __exports__